<template>
	<BaseCard class="flex items-center gap-4 py-2 pr-5 pl-2" alt>
		<ItemIcon :src="caseIcon(uuid, true)" :name="name" alt noBackdrop />
		<div class="text-label-primary min-w-0 flex-1 truncate text-sm font-medium">
			{{ name }}
		</div>
		<CoinPrice :price="price" />
	</BaseCard>
</template>
<script setup lang="ts">
import ItemIcon from './ItemIcon.vue'
import CoinPrice from './CoinPrice.vue'
import { caseIcon } from '@/utils/urls'
import BaseCard from './BaseCard.vue'

defineProps<{
	uuid: string
	name: string
	price: number
}>()
</script>
